import Vue from 'vue'
import App from './App.vue'
import router from './deps/router'
import store from './store'
import {getAppStore, setAppStore} from './deps/utils'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/psh.styl'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

Vue.use(preview);
Vue.use(ElementUI);
Vue.config.productionTip = false;

setAppStore('router', router);
setAppStore('methods', {
  ...getAppStore('methods'),
  showIndicator: (message) => {
    store.commit('showLoading', message || '加载中, 请稍等...')
  },
  hideIndicator: () => {
    store.commit('closeLoading')
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
});
